import { useState } from 'react';

export const useToggle = (initialValue = false) => {
    const [ show, setShow ] = useState(initialValue);
    return [ show, () => setShow(!show) ];
};
